import React from "react";
import PropTypes from "prop-types";
import { fromJS, Map } from "immutable";
import { Link } from "react-router-dom";
import { AuditFields, EditButton, PartNumber } from "MODULES/shared/components";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import ShippingAddress from "MODULES/Orders/shared/ShippingAddress";
import { shortDate, monthYear, monthFullYear } from "LIB/formatters/date";
import { INCIDENT } from "MODULES/PurchaseOrders/constants";
import {
  CONDITION,
  EXPIRATION,
  LOCATION,
  MODIFIED,
  PART_ID,
  SERIAL_NUMBER,
  TAG_DATE,
  TAGGED_BY
} from "MODULES/inventories/constants";
import { DOM, PART, PMA } from "MODULES/parts/constants";
import { truncate } from "LIB/formatters/text";
import { AWB_NUMBER, QUANTITY, UUID } from "APP_ROOT/constants";
import { Col } from "react-bootstrap";
import {
  DER,
  IMPERFECT_TRACE,
  IMPERFECT_TRACE_REASON
} from "MODULES/companies/constants";
import TableDetailRow from "MODULES/shared/components/DetailTable/Detail";
import {
  RECEIVING_TYPES,
  CONDITION_TYPES,
  CONSIGNMENT_REFERENCE,
  CONSIGNMENT_BUYER_ID,
  CONSIGNMENT_CO_BUYER_ID,
  CONSIGNOR_PERCENTAGE,
  RECEIVING_TYPE,
  RECEIVED_VIRTUALLY
} from "../constants";
import Form from "../Edit/Form";

export default class SideBar extends React.Component {
  state = {
    editModalOpen: false
  };

  openEditModal = () => this.setState({ editModalOpen: true });
  closeEditModal = () => this.setState({ editModalOpen: false });

  render() {
    const { receivingRecord } = this.props;
    const { editModalOpen } = this.state;
    const editableFormValues = [
      "demerit",
      RECEIVING_TYPE,
      PART_ID,
      SERIAL_NUMBER,
      CONDITION,
      DER,
      IMPERFECT_TRACE,
      IMPERFECT_TRACE_REASON,
      INCIDENT,
      QUANTITY,
      DOM,
      EXPIRATION,
      TAG_DATE,
      TAGGED_BY,
      AWB_NUMBER,
      LOCATION,
      MODIFIED,
      PMA,
      CONSIGNMENT_REFERENCE,
      CONSIGNMENT_BUYER_ID,
      CONSIGNMENT_CO_BUYER_ID,
      CONSIGNOR_PERCENTAGE,
      RECEIVED_VIRTUALLY
    ];

    const editInitialValues = editableFormValues.reduce(
      (acc, item) => {
        acc[item] = receivingRecord.get(item);
        return acc;
      },
      {
        read_only_consignment: receivingRecord.get(CONSIGNMENT_REFERENCE)
      }
    );
    const inventoryId = receivingRecord.getIn(["inventories", 0, UUID]);
    const receivingType = receivingRecord.get(RECEIVING_TYPE);

    const tagFields = ["pma", "asa", "faa", "easa", "uk_caa", "caac", "tcca"];
    const renderedFields = tagFields
      .filter(field => receivingRecord.get(field) === true)
      .map(field => (
        <span key={field} className="badge" style={{ marginRight: "5px" }}>
          {field.replace("_", " ").toUpperCase()}
        </span>
      ));

    return (
      <Col md={3}>
        <div className="panel panel-default">
          <div className="panel-body">
            <h2 style={{ marginTop: 10 }}>
              Part Details
              <EditButton handleClick={this.openEditModal} />
            </h2>
            <Modal
              open={editModalOpen}
              close={this.closeEditModal}
              dialogClass="modal-md"
            >
              <Header>
                <Close close={this.closeEditModal} />
                <h4 className="modal-title">Edit Details</h4>
              </Header>
              <Form
                close={this.closeEditModal}
                initialValues={editInitialValues}
                receivingType={receivingType}
                selectedPart={receivingRecord.get(PART).toJS()}
                receivingRecord={receivingRecord.toJS()}
                taggedBy={receivingRecord.get(TAGGED_BY)}
              />
            </Modal>
            <table className="table table-condensed">
              <tbody>
                <tr>
                  <th className="text-right">Part #</th>
                  <td>
                    <PartNumber part={receivingRecord.toJS().part} />
                  </td>
                </tr>
                <tr>
                  <th className="text-right">Part Desc.</th>
                  <td>{receivingRecord.getIn(["part", "description"])}</td>
                </tr>
                <tr>
                  <th className="text-right">Serial #</th>
                  <td>
                    {inventoryId ? (
                      <a href={`/inventories/${inventoryId}`}>
                        {receivingRecord.get(SERIAL_NUMBER)}
                      </a>
                    ) : (
                      receivingRecord.get(SERIAL_NUMBER)
                    )}
                  </td>
                </tr>
                <tr>
                  <th className="text-right">Receiving Type</th>
                  <td>{RECEIVING_TYPES[receivingType].label}</td>
                </tr>
                <tr>
                  <th className="text-right">Received From</th>
                  <td>{truncate(receivingRecord.toJS().company_name, 19)}</td>
                </tr>
                <tr>
                  <th className="text-right">REF #</th>
                  <td>
                    <a
                      href={`/${RECEIVING_TYPES[receivingType]
                        .link}/${receivingRecord.getIn([
                        "reference_record",
                        UUID
                      ]) || receivingRecord.get("reference_record_id")}`}
                    >
                      {receivingRecord.get("reference_number")}
                    </a>
                  </td>
                </tr>
                <tr>
                  <th className="text-right">AWB #</th>
                  <td>{receivingRecord.get("awb_number")}</td>
                </tr>
              </tbody>
            </table>
            <hr className="hr-dashed hr-xs" />
            <table className="table table-condensed">
              <tbody>
                <tr>
                  <th className="text-right">Created By</th>
                  <td>{receivingRecord.getIn(["created_by", "full_name"])}</td>
                </tr>
                <tr>
                  <th className="text-right">Buyer/Seller</th>
                  <td>{receivingRecord.getIn(["buyer", "full_name"])}</td>
                </tr>
              </tbody>
            </table>
            <hr className="hr-dashed hr-xs" />
            <table className="table table-condensed">
              <tbody>
                <tr>
                  <th className="text-right">Store LOC</th>
                  <td>{receivingRecord.get("store_location")}</td>
                </tr>
                <tr>
                  <th className="text-right">LOC</th>
                  <td>{receivingRecord.get("location")}</td>
                </tr>
                {receivingRecord.getIn(["ware_house", "name"]) && (
                  <TableDetailRow
                    label="Warehouse"
                    value={receivingRecord.getIn(["ware_house", "name"])}
                  />
                )}
              </tbody>
            </table>
            <hr className="hr-dashed hr-xs" />
            <table className="table table-condensed">
              <tbody>
                <tr>
                  <th className="text-right">CD Rec.</th>
                  <td>
                    {CONDITION_TYPES[receivingRecord.get("condition")].label}
                  </td>
                </tr>
                <tr>
                  <th className="text-right">QTY Rec.</th>
                  <td>{receivingRecord.get("quantity")}</td>
                </tr>
                <tr>
                  <th className="text-right">DOM</th>
                  <td>{monthFullYear(receivingRecord.get("dom"))}</td>
                </tr>
                <tr>
                  <th className="text-right">EXP</th>
                  <td>{shortDate(receivingRecord.get("expiration"))}</td>
                </tr>
                <tr>
                  <th className="text-right">Tag Date</th>
                  <td>{monthYear(receivingRecord.get("tag_date"))}</td>
                </tr>
                <tr>
                  <th className="text-right">Tagged By</th>
                  <td>{receivingRecord.get("tagged_by")}</td>
                </tr>
                <tr>
                  <th className="text-right">Tag Types</th>
                  <td>{renderedFields}</td>
                </tr>
              </tbody>
            </table>
            <hr className="hr-dashed hr-xs" />
            <table className="table table-condensed">
              <tbody>
                <tr>
                  <th className="text-right">Consignment Ref #</th>
                  <td>
                    {receivingRecord.toJS().consignment ? (
                      <Link
                        to={`/consignments/${receivingRecord.toJS().consignment
                          .uuid}`}
                      >
                        {receivingRecord.get("consignment_reference")}
                      </Link>
                    ) : (
                      receivingRecord.get("consignment_reference")
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
            <hr className="hr-xs hr-dashed" />
            <ShippingAddress
              shippingType={"ship_to"}
              record={receivingRecord}
              renderPreferences={false}
            />
            <hr />
            <AuditFields record={fromJS(receivingRecord)} multiLine />
          </div>
        </div>
      </Col>
    );
  }
}

SideBar.propTypes = {
  receivingRecord: PropTypes.instanceOf(Map).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/Receiving/Detail/SideBar.jsx